import { Typography, styled } from '@mui/material';

import { ENVIRONMENT } from 'src/config-global';
import { ENVIRONMENTS } from 'src/constants/misc';

const BannerBg = styled('div')({
  backgroundColor: ENVIRONMENT === ENVIRONMENTS.stage ? '#FFF7AF' : '#EBC9C9',
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  zIndex: '1102',
  height: '1.875rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
});

const BannerText = styled(Typography)({
  fontWeight: 500,
  fontSize: '0.875rem',
  lineHeight: '1.5rem',
  color: '#212529',
  textAlign: 'center',
  textTransform: 'uppercase',
  width: '100%',
});

const Banner = () => {
  if (ENVIRONMENT !== ENVIRONMENTS.prod) {
    return (
      <BannerBg>
        <BannerText>{`${ENVIRONMENT}`}</BannerText>
      </BannerBg>
    );
  }

  return null;
};

export default Banner;
